import { render, staticRenderFns } from "./dialogPolicyDetail.vue?vue&type=template&id=5aab5fb7&scoped=true"
import script from "./dialogPolicyDetail.vue?vue&type=script&lang=js"
export * from "./dialogPolicyDetail.vue?vue&type=script&lang=js"
import style0 from "./dialogPolicyDetail.vue?vue&type=style&index=0&id=5aab5fb7&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aab5fb7",
  null
  
)

export default component.exports